import {Directive, forwardRef} from '@angular/core';
import {FormControl, NG_VALIDATORS, Validator} from '@angular/forms';

export const REGEX_PHONENUMBER = /^[\s]*[+\d][\s\d]*$/;

// so viele Blanks wies beliebt, dann entweder Zahl oder + und danch nur noch Zahlen

@Directive({
    providers: [
        {
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MobilnummerValidatorDirective),
        },
    ],
    selector: '[lvTsLintSatisfy],[lvMobilnummerValidator]',
    standalone: false
})

export class MobilnummerValidatorDirective implements Validator {


  public validate(control: FormControl): {} {
    return this.validatePartialPhonenumber(control.value?.nummer);
  }

  public validatePartialPhonenumber(partialPhonenumber: string): {} {
    if (!partialPhonenumber || partialPhonenumber.length === 0) {
      return null;
    }
    if (!REGEX_PHONENUMBER.test(partialPhonenumber)) {
      return {ERROR: 'WRONG_PHONE_LETTER'};
    }
    let valueWithoutBlanks = partialPhonenumber.replace(/\s/g, ''); // ersetze alle blanks
    valueWithoutBlanks = valueWithoutBlanks.replace(/\+/g, ''); // ersetze alle +
    if (valueWithoutBlanks && valueWithoutBlanks.length < 7) {
      return {PARTIAL: 'WRONG_PHONE_TO_SHORT'};
    }
    if (valueWithoutBlanks && valueWithoutBlanks.length > 15) {
      return {PARTIAL: 'WRONG_PHONE_TO_LONG'};
    }

    if (REGEX_PHONENUMBER.test(partialPhonenumber)) {
      return null;
    }

    return {ERROR: 'WRONG_PHONE_LETTER'};
  }
}
